<template>
    <div class="mt-8">
        <div class="mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3" v-auto-animate>
                <component
                    :is="widget.name"
                    v-for="widget in widgets"
                    :widget="widget"
                    :key="`${widget.name}_${widget.uuid}`"
                />
            </div>
        </div>
    </div>
</template>
<script>
import BookmarksWidget from '@/components/Widgets/Teacher/BookmarksWidget.vue';
import QuickOptionsWidget from '@/components/Widgets/Teacher/QuickOptionsWidget.vue';
import BirthdaysWidget from '@/components/Widgets/Teacher/BirthdaysWidget.vue';
import GraphWidget from '@/components/Widgets/Teacher/GraphWidget.vue';
import GroupFoulsWidget from '@/components/Widgets/Teacher/GroupFoulsWidget.vue';
import ProgrammingCalendarDayWidget from '@/components/Widgets/Teacher/ProgrammingCalendarDayWidget.vue';
import SelfAttendanceWidget from '@/components/Widgets/Teacher/SelfAttendanceWidget.vue';
import SchoolOnboardingWidget from '@/components/Widgets/Admin/SchoolOnboardingWidget.vue';
import CalendarChartWidget from '@/components/Widgets/Teacher/CalendarChartWidget.vue';
import QuestionReviewsWidget from '@/components/Widgets/Teacher/QuestionReviewsWidget.vue';
import BasicWidget from '@/components/Widgets/Teacher/BasicWidget.vue';

export default {
    name: 'DashboardTeacherWidgets',
    components: {
        'basic-widget': BasicWidget,
        'self-attendance': SelfAttendanceWidget,
        'programming-calendar-day': ProgrammingCalendarDayWidget,
        'group-fouls': GroupFoulsWidget,
        'teacher-bookmarks': BookmarksWidget,
        'quick-options': QuickOptionsWidget,
        'teacher-birthdays': BirthdaysWidget,
        'simple-graph': GraphWidget,
        'school-onboarding': SchoolOnboardingWidget,
        'teacher-onboarding': SchoolOnboardingWidget,
        'calendar-graph': CalendarChartWidget,
        'question-reviews': QuestionReviewsWidget,
    },
    props: ['widgets'],
};
</script>
